export enum ErrorCategory {
    Network = 'Network',
}

export class Analytics {}

/* eslint-disable @typescript-eslint/no-unused-vars */
export const logError = async (category: ErrorCategory, message: string, params?: unknown): Promise<void> => {
    console.error(`>>>> [ERR] ${category}:`, message, '')
}
